export const cascaderFilter = (inputValue, path) => {
  return path.some(
    option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
};

export const selectFilter = (inputValue, option) => {
  return option.label.toLowerCase().includes(inputValue.toLowerCase());
};

// Used for Test Users UI. convert array of options label from a React JSX object into a plain string for searching the label
export const selectFilterForCampaignsListWithTag = (inputValue, option) => {
  const optionValueToSearch = `${option.label.props.children[0]} ${option.value}`;
  return optionValueToSearch.toLowerCase().includes(inputValue.toLowerCase());
};

export const selectFilterForJSXLabel = (inputValue, option) => {
  // Extract text content from the JSX label structure
  if (option.label && option.label.props && option.label.props.children) {
    // Join all string children to create a searchable text
    const textContent = option.label.props.children
      .filter(child => typeof child === "string")
      .join(" ");

    return textContent.toLowerCase().includes(inputValue.toLowerCase());
  }

  // Fallback to using the value if we can't parse the label
  return option.value.toLowerCase().includes(inputValue.toLowerCase());
};
